import type { SportSuggestion as Suggestion } from '@painpal/contracts';
import { useAcceptSportSuggestion, useDismissSportSuggestion } from '../../api/mutations';
import type { SportSuggestionAction } from '../../api/paths';
import { errorMessage } from '../../lib/api';
import { suggestionCopy } from './thresholdModel';
import styles from './suggestions.module.css';

const GROUP_NAME: Record<SportSuggestionAction, string> = {
  'run-pace': 'Run threshold pace suggestion',
  'run-lthr': 'Run threshold HR suggestion',
  'other-lthr': 'Other sports threshold HR suggestion',
};

export function SportSuggestion({ action, suggestion, compact = false }: { action: SportSuggestionAction; suggestion: Suggestion | undefined; compact?: boolean }) {
  const accept = useAcceptSportSuggestion(action);
  const dismiss = useDismissSportSuggestion(action);
  if (suggestion?.state !== 'suggest') return null;
  const copy = suggestionCopy(action, suggestion);
  const busy = accept.isPending || dismiss.isPending;
  const error = accept.error ?? dismiss.error;
  return (
    <div className={styles.sportOffer} data-compact={compact || undefined} role="group" aria-label={GROUP_NAME[action]}>
      <p className={styles.values}>
        <span className={styles.label}>{copy.label}</span>
        <span className={styles.strava}>{copy.value}</span>
        {copy.yours !== null && <span className={styles.yours}>{copy.yours}</span>}
      </p>
      {copy.why !== null && <p className={styles.why}>{copy.why}</p>}
      <div className={styles.actions}>
        <button type="button" className={`btn btn-pink ${styles.action}`} disabled={busy} onClick={() => accept.mutate()}>USE IT</button>
        <button type="button" className={styles.dismiss} disabled={busy} onClick={() => dismiss.mutate(suggestion.value)}>DISMISS</button>
      </div>
      {error !== null && <p role="alert" className={`alert-hot ${styles.error}`}>{errorMessage(error)}</p>}
    </div>
  );
}
